import gql from 'graphql-tag'

/**
 * Close an advice which has status - "PARTIALLY_FINISHED"
 */
const stockAdviceCloseQuery = gql`
  query stockAdviceClose($id: String!) {
    stockAdviceClose(id: $id, input: {}) @rest(type: "StockAdviceResult", method: "PUT", path: "stock-advice/close/{args.id}") {
      id
      user
      organisation
      warehouse
      wms
      supplier
      packagingUnit
      countOfUnits
      createdAt
      status
      manualInput
      items
      note
      internalId
      wmsInternalId
      expectedAt
      createdAt
      ref1
      ref2
      ref3
      changedAt
    }
  }
`

export default stockAdviceCloseQuery
